export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq'
  },
  {
    title: that.$l('table_input_teamLeaderName') || '团队负责人',
    field: 'teamLeaderName',
    minWidth: 160,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string'
  },
  {
    title: that.$l('table_input_rateOfProgress') || '录入进度',
    field: 'rateOfProgress',
    minWidth: 230,
    headerAlign: 'center',
    align: 'left',
    sortable: true,
    sortType: 'number',
    slots: { default: 'rateOfProgress' }
  },
  {
    title: that.$l('table_input_planCount') || '在手订单',
    field: 'planCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_inputCount') || '录入订单',
    field: 'inputCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_invalidCount') || '无效订单',
    field: 'invalidCount',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_salePriceAmountRmb') || '收入',
    field: 'v_salePriceAmountRmb',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  },
  {
    title: that.$l('table_input_priceAmountRmb') || '成本',
    field: 'v_priceAmountRmb',
    minWidth: 150,
    headerAlign: 'center',
    align: 'right',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'number'
  }
]
